import React, { Component } from 'react';
import Constants from '../../../../definitions/constants';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import HoverTooltip from './hoverTooltip';

import TextBox from '../inputs/textBox';

const DraggableItem = props => {
  const {
    className,
    objectType,
    title,
    toolTip,
  } = props;  
  return (    
      <div
        className={"editor_input_object editor_input_type_" + objectType + (className ? " " + className : "")}
        >
        <div title={title} className={"editor_input_object_inner"}>
          <div className={"editor_input_object_inner_name"}>
            {props.children}
            {toolTip && (
              <HoverTooltip 
                toolTip={toolTip}
                toolTipType={Constants.interface.toolTip.formulaDraggable}
                placement="right-end" 
                enterDelay={300} 
                leaveDelay={100}
              >
                <div className="editor_input_object_inner_name_tooltip_icon">
                  <i 
                    className="fas fa-info-circle"
                  />
                </div>
              </HoverTooltip>
            )}
          </div>
        </div>
      </div>
   );
};

class DraggableList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: ""
    };
  }
  
  handleOnChangeTopControls = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      searchText: value
    });
  };

  render() {
    const {
      className,
      list,
      labelLocale,
      searchTextLocale,
      idAccesor,
      labelAccesor,
      objectType,
      disabled
    } = this.props;
    return (
      <div className={"custom-input draggable-list free-text-list" + (className ? " " + className : "")}>
        <div className="draggable-list-label free-text-list-label">
          {labelLocale}
        </div>
        <TextBox 
          className="top_controls_search"
          styleType={Constants.interface.inputs.styleType.OUTLINED}
          type={Constants.interface.inputs.type.TEXT}
          value={this.state.searchText}
          onChange={this.handleOnChangeTopControls}
          labelLocale={searchTextLocale}
        />
        <div className="draggable-list-list-wrapper free-text-list-list-wrapper">
          <Droppable droppableId={"droppable-list-" + objectType} isDropDisabled={true} type={objectType}>
            {(provided, snapshot) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {list && list.map((item,i) => {
                  if(this.state.searchText!="" && item[this.props.labelAccesor].toUpperCase().indexOf(this.state.searchText.toUpperCase()) == -1) {
                    return null;
                  }
                  else {
                    return (
                      <Draggable isDragDisabled={disabled} key={i} draggableId={objectType + "_" + item[this.props.idAccesor]} index={i}>
                        {(provided, snapshot) => (
                          <React.Fragment>
                            <div
                              className="editor_input_object_drag_wrapper"
                              ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              style={provided.draggableProps.style}
                            >                   
                              <DraggableItem title={item[this.props.labelAccesor]} objectType={objectType} className={(snapshot.isDragging ? "editor_input_object_dragging" : "") + (item.extraClass ? " " + item.extraClass : "")} toolTip={item.tooltipDescription ? (item.tooltipDescription.show ? item.id : null): null}>
                                {item[this.props.labelAccesor]}
                              </DraggableItem>
                            </div>
                            {snapshot.isDragging && (
                              <DraggableItem objectType={objectType} className={item.extraClass}>
                                {item[this.props.labelAccesor]}
                              </DraggableItem>
                            )}
                          </React.Fragment>
                        )}
                      </Draggable>
                    );
                  }
                })}
                {provided.placeholder}
              </div>            
            )}
          </Droppable>
        </div>
      </div>
    );
  }
}

export default DraggableList;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/draggableList.jsx